/**
 * Runner Map Integration
 * Google Maps visualization for runner locations
 */

let map = null;
let markers = [];
let markerCluster = null;
let infoWindow = null;

function showSearch(locationId) {
  if (!locationId) {
    return false;
  }

  $('#searchresults').html('<p>Loading data&#8230;</p>');
  $('#searchresults').load('/ajax/search.php?id=' + encodeURIComponent(locationId));
  return false;
}

// Expose for inline onclick from Google info window HTML
window.runnermapShowSearch = showSearch;

/**
 * Initialize Google Map
 */
function initRunnerMap() {
  const mapElement = document.getElementById('map');
  
  if (!mapElement) {
    return;
  }
  
  // Default center (Utica, NY)
  const center = { lat: 43.1009, lng: -75.2327 };
  
  map = new google.maps.Map(mapElement, {
    zoom: 8,
    center: center,
    mapTypeId: 'roadmap',
    styles: getMapStyles()
  });
  
  infoWindow = new google.maps.InfoWindow();

  // Load all city-level runner locations
  loadRunnerMarkers();
}

/**
 * Load runner markers from API
 */
function loadRunnerMarkers() {
  $.ajax({
    url: '/ajax/markers.json.php?data=cities',
    method: 'GET',
    dataType: 'json',
    success: function(data) {
      if (Array.isArray(data)) {
        addMarkers(data);
      }
    },
    error: function(xhr, status, error) {
      console.error('Failed to load markers:', error);
    }
  });
}

/**
 * Add markers to the map
 */
function addMarkers(locations) {
  // Clear existing markers
  clearMarkers();
  
  const markerIcon = {
    url: '/assets/images/icons/marker_large.png',
    scaledSize: new google.maps.Size(28, 28),
    anchor: new google.maps.Point(14, 14)
  };

  const bounds = new google.maps.LatLngBounds();

  locations.forEach(location => {
    const lat = parseFloat(location.latitude);
    const lng = parseFloat(location.longitude);
    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return;
    }

    const city = location.city || '';
    const state = location.state || '';
    const country = location.country || '';
    const runners = parseInt(location.runners || 0, 10);

    const marker = new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: map,
      icon: markerIcon,
      title: runners + ' runners from ' + city
    });

    const titleBits = [city, state, country].filter(Boolean).join(', ');
    const markerHtml = `<div class="marker-info">
      <p style="margin:0 0 6px 0;"><img src="/assets/images/icons/marker_large.png" alt="Boilermaker marker" style="width:24px;height:24px;vertical-align:middle;"></p>
      <h3>${titleBits}</h3>
      <p><a href="#" onclick="return window.runnermapShowSearch(${location.id});">View ${runners} Runners</a></p>
    </div>`;

    marker.addListener('click', function() {
      infoWindow.setContent(markerHtml);
      infoWindow.open(map, marker);
    });

    bounds.extend(marker.getPosition());
    markers.push(marker);
  });

  // Keep existing map zoom if markers are sparse; otherwise fit all markers.
  if (markers.length > 1) {
    map.fitBounds(bounds);
  }

  // Add marker clustering for better performance
  if (typeof MarkerClusterer !== 'undefined' && markers.length > 50) {
    markerCluster = new MarkerClusterer(map, markers, {
      imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      maxZoom: 12
    });
  }
}

/**
 * Clear all markers from map
 */
function clearMarkers() {
  markers.forEach(marker => marker.setMap(null));
  markers = [];
  
  if (markerCluster) {
    markerCluster.clearMarkers();
    markerCluster = null;
  }
}

/**
 * Get map styles based on theme
 */
function getMapStyles() {
  const theme = document.documentElement.getAttribute('data-theme') || 'light';
  const hideRoads = {
    featureType: 'road',
    stylers: [{ visibility: 'off' }]
  };
  const hideRoadLabels = {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }]
  };
  const hidePOI = {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }]
  };
  const hidePOILabels = {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }]
  };
  
  if (theme === 'dark') {
    return [
      { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#d59563' }]
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#d59563' }]
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#263c3f' }]
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#6b9a76' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#38414e' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#212a37' }]
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9ca5b3' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#746855' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#1f2835' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#f3d19c' }]
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{ color: '#2f3948' }]
      },
      {
        featureType: 'transit.station',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#d59563' }]
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#17263c' }]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#515c6d' }]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#17263c' }]
      },
      hideRoads,
      hideRoadLabels,
      hidePOI,
      hidePOILabels
    ];
  }
  
  return [hideRoads, hideRoadLabels, hidePOI, hidePOILabels]; // Light theme with roads and POI hidden
}

/**
 * Update map theme when theme changes
 */
function updateMapTheme() {
  if (map) {
    map.setOptions({ styles: getMapStyles() });
  }
}

// Initialize on page load
$(document).ready(function() {
  if ($('#map').length) {
    initRunnerMap();
  }
  
  // Listen for theme changes
  document.addEventListener('themeChanged', updateMapTheme);
});

// Export for use in other modules
export { initRunnerMap, updateMapTheme };
